import { getIn, useFormikContext } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FormField } from 'components/form/formField/formField';
import { SearchableSelect } from 'components/inputs/select/searchableSelect';
import { SelectItem } from 'components/inputs/select/select';

import { ESTIMATED_ANNUAL_REVENUE_USD_OPTIONS, FORMIK_INITIAL_VALUES, LABELS } from '../../../../keys';
import { Container, Label } from './styles';

interface Props {
  // path to the field in the formik values, must point to a field of an array type: IdentifyingInformationType[]
  fieldPath: string;
  //  for errors coming from backend
  error?: Record<string, string>;
  isPartialMode?: boolean;
}

const EstimatedAnnualRevenue = ({ fieldPath, error, isPartialMode = false }: Props) => {
  const { t } = useTranslation();
  const { values, touched, errors, setFieldValue } = useFormikContext<typeof FORMIK_INITIAL_VALUES>();

  const estimatedAnnualRevenue = `${fieldPath}`;
  const estimatedAnnualRevenueError = getIn(errors, fieldPath);
  const estimatedAnnualRevenueTouched = getIn(touched, fieldPath);

  const estimatedAnnualRevenueValue = getIn(values, fieldPath) as SelectItem['key'];

  return (
    <Container>
      <Label>{t(LABELS.SECTIONS.ESTIMATED_ANNUAL_REVENUE_USD.TITLE)}</Label>

      <FormField error={error?.[fieldPath]}>
        {/* showing BE errors at the top, move it? */}
        {null}
      </FormField>

      <FormField error={estimatedAnnualRevenueError && estimatedAnnualRevenueTouched ? estimatedAnnualRevenueError : undefined}>
        <SearchableSelect<SelectItem, false>
          fullWidth
          value={ESTIMATED_ANNUAL_REVENUE_USD_OPTIONS.find((item) => item.key === estimatedAnnualRevenueValue)}
          items={ESTIMATED_ANNUAL_REVENUE_USD_OPTIONS}
          placeholder={t(LABELS.SECTIONS.ESTIMATED_ANNUAL_REVENUE_USD.PLACEHOLDER)}
          onChange={(selectItem) => {
            setFieldValue(estimatedAnnualRevenue, selectItem?.key);
          }}
          getItemLabel={(item) => item.label}
          multiple={false}
          closeDropdownOnSelect
          error={
            error?.[fieldPath] || (estimatedAnnualRevenueError && estimatedAnnualRevenueTouched) ? estimatedAnnualRevenueError : undefined
          }
          isOriginalOrder
        />
      </FormField>
    </Container>
  );
};

export default EstimatedAnnualRevenue;
